import { render } from "./NewPasswordReset.vue?vue&type=template&id=1a48904e&scoped=true"
import script from "./NewPasswordReset.vue?vue&type=script&lang=js"
export * from "./NewPasswordReset.vue?vue&type=script&lang=js"

import "./NewPasswordReset.vue?vue&type=style&index=0&id=1a48904e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a48904e"]])

export default __exports__